import React, { createContext, ReactElement, useReducer, ReactNode } from 'react';
import { ClinicWidgetRequestType, FormTemplateType } from 'shared/types/graphql';
import { formsReducer } from './formsReducer';
import { IQuestion } from '../FormsContent/FormsDrafting/Question';

interface Context {
  formId: string;
  isActive: boolean;
  formName: string;
  introMessage: string;
  questions: IQuestion[];
  formTemplateType: FormTemplateType;
  clinicWidgetRequestTypes: ClinicWidgetRequestType[];
  hasLinkedAutomations: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch?: any;
  isTemplateSelectorShown: boolean;
  hasChanges: boolean;
  isNewForm: boolean;
  hasFormTemplateRecentlyChanged: boolean;
  autoExportEnabled: boolean;
}

const initialContext = {
  formId: '',
  isActive: false,
  formName: '',
  introMessage: '',
  questions: [],
  formTemplateType: FormTemplateType.General,
  clinicWidgetRequestTypes: [],
  hasLinkedAutomations: false,
  isTemplateSelectorShown: false,
  hasChanges: false,
  isNewForm: false,
  hasFormTemplateRecentlyChanged: false,
  autoExportEnabled: false,
};

export const FormsContext = createContext<Context>(initialContext);

interface Props {
  children: ReactNode;
}

function FormsContextProvider({ children }: Props): ReactElement {
  const [formsContext, dispatch] = useReducer(formsReducer, initialContext);

  return <FormsContext.Provider value={{ ...formsContext, dispatch }}>{children}</FormsContext.Provider>;
}

export default FormsContextProvider;
